import { View, Image, Text, ImageBackground, StyleSheet } from "react-native";
import {
  StatisticsDownLightPng,
  StatisticsText,
  TimerBackgroundPng,
} from "../../../assets";
import { isPortrait } from "../../../utils/common";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useMemo } from "react";
import { secondsToDHM } from "../../../utils/helpers/time";
import { useTranslation } from "react-i18next";

const Statistics = ({
  user,
}: {
  user?: {
    username: string;
    avatarFileId: string | null;
    chips: number;
    level: number;
  };
}) => {
  const { t } = useTranslation();
  const timePlayedSecs = useSelector(
    (s: RootState) => s.auth.statistics?.gamesData.svarka_time_played
  );

  const { dd, hh, mm, days, hours, minutes } = useMemo(
    () => secondsToDHM(timePlayedSecs),
    [timePlayedSecs]
  );
  return (
    <View style={styles.container}>
      <View style={styles.textRow}>
        <Text style={styles.text}> {t("T_SITE_PROFILE_STATISTICS")}</Text>
      </View>

      <View style={styles.textRow}>
        <Image source={StatisticsDownLightPng} style={styles.statisticsLight} />
      </View>

      <View style={styles.textRow}>
        <Text style={styles.label}>{t("T_SITE_PROFILE_TIME_IN_PLAY")}:</Text>
      </View>

      <ImageBackground
        source={TimerBackgroundPng}
        style={styles.timerContainer}
        resizeMode="cover"
      >
        <View style={styles.timeRow}>
          <View style={styles.timeBlock}>
            <Text style={styles.timeValue}>{dd}</Text>
            <Text style={styles.timeLabel}>
              {days === 1 ? t("T_Day") : t("T_Days")}
            </Text>
          </View>

          <Text style={styles.separator}>:</Text>

          <View style={styles.timeBlock}>
            <Text style={styles.timeValue}>{hh}</Text>
            <Text style={styles.timeLabel}>
              {hours === 1 ? t("T_SITE_HOUR") : t("T_SITE_HOURS")}
            </Text>
          </View>

          <Text style={styles.separator}>:</Text>

          <View style={styles.timeBlock}>
            <Text style={styles.timeValue}>{mm}</Text>
            <Text style={styles.timeLabel}>
              {minutes === 1 ? t("T_SITE_MINUTE") : t("T_SITE_MINUTES")}
            </Text>
          </View>
        </View>
      </ImageBackground>
    </View>
  );
};

export default Statistics;

const styles = StyleSheet.create({
  container: {
    marginTop: 0,
    alignItems: "center",
    width: "100%",
  },
  textRow: {
    marginTop: 10,
  },
  statisticsText: {
    width: 112,
    height: 21,
  },
  statisticsLight: {
    width: 200,
    height: 8,
  },
  label: {
    color: "white",
    fontSize: 18,
    marginLeft: 5,
    textTransform: "uppercase",
  },
  timerContainer: {
    width: isPortrait ? 170 : 208,
    height: isPortrait ? 50 : 70,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 10,
  },
  timeRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: isPortrait ? 4 : 16,
    marginTop: -6,
  },
  timeBlock: {
    alignItems: "center",
  },
  timeValue: {
    fontSize: isPortrait ? 18 : 22,
    fontWeight: "bold",
    color: "white",
  },
  timeLabel: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#ffcc00",
    letterSpacing: 1,
    textTransform: "uppercase",
  },
  separator: {
    fontSize: 20,
    color: "white",
    fontWeight: "bold",
    marginBottom: 18,
  },
  text: {
    fontSize: 20,
    fontWeight: "700",
    letterSpacing: 1.2,
    color: "#E0E0E0",
    textShadowColor: "rgba(0, 0, 0, 0.6)",
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 2,
    textTransform: "uppercase",
    paddingBottom: 2,
  },
});
